import React from "react";
import PrivateRoute from "./routes/PrivateRoute";
import Login from "./pages/auth/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
import MainLayout from "./layouts/MainLayout";
import Profile from "./pages/profile/Profile";
import LotteryListPage from "./pages/lottery/LotteryListPage";
import Feedback from "./pages/ticket/Feedback";
import Ticket from "./pages/ticket/Ticket";
import LotteryDetail from "./pages/lottery/detail/LotteryDetail";
import MassMessage from "./pages/sms/MassMessage";
import Staff from "./pages/staff/Staff";
import News from "./pages/news/News";
import NewsDetail from "./pages/news/detail/NewsDetail";
import Bank from "./pages/bank/account/Bank";
import AccountStatement from "./pages/bank/statement/AccountStatement";
import CallCenter from "./pages/call-center/CallCenter";
import CallCenterDetail from "./pages/call-center/detail/CallCenterDetail";
import Reward from "./pages/reward/Reward";
import Grants from "./pages/reward/grants/Grants";
import Report from "./pages/report";
import Roles from "./pages/roles/Roles";
import PermissionRoute from "./routes/PermissionRoute";

const App = () => {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />
      {/* Private */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        {/* --- DASHBOARD --- */}
        <Route path="dashboard" element={<Dashboard />} />
        {/* --- LOTTERY --- */}
        <Route
          path="lottery/active"
          element={
            <PermissionRoute perm="READ_LOTTERY">
              <LotteryListPage type="active" />
            </PermissionRoute>
          }
        />
        <Route
          path="lottery/completed"
          element={
            <PermissionRoute perm="READ_LOTTERY">
              <LotteryListPage type="completed" />
            </PermissionRoute>
          }
        />
        <Route
          path="lottery/draft"
          element={
            <PermissionRoute perm="READ_LOTTERY">
              <LotteryListPage type="draft" />
            </PermissionRoute>
          }
        />
        <Route
          path="lottery/:type/:id/edit"
          element={
            <PermissionRoute perm="READ_LOTTERY">
              <LotteryDetail />
            </PermissionRoute>
          }
        />
        {/* --- TICKET --- */}
        <Route
          path="ticket/engagement"
          element={
            <PermissionRoute perm="VIEW_TICKET">
              <Ticket />
            </PermissionRoute>
          }
        />
        <Route
          path="ticket/feedback"
          element={
            <PermissionRoute perm="VIEW_COMPLAINT">
              <Feedback />
            </PermissionRoute>
          }
        />
        {/* --- REPORT --- */}
        <Route
          path="report"
          element={
            <PermissionRoute perm="REPORT_LOTTERY">
              <Report />
            </PermissionRoute>
          }
        />
        {/* --- PROFILE --- */}
        <Route path="profile" element={<Profile />} />
        {/* --- SMS --- */}
        <Route
          path="sms"
          element={
            <PermissionRoute perm="READ_SMS">
              <MassMessage />
            </PermissionRoute>
          }
        />
        {/* --- STAFF --- */}
        <Route
          path="staff"
          element={
            <PermissionRoute perm="VIEW_USER">
              <Staff />
            </PermissionRoute>
          }
        />
        {/* --- BANK --- */}
        <Route
          path="bank/account"
          element={
            <PermissionRoute perm="VIEW_BANK">
              <Bank />
            </PermissionRoute>
          }
        />
        <Route
          path="bank/statement"
          element={
            <PermissionRoute perm="VIEW_BANK_STATEMENT">
              <AccountStatement />
            </PermissionRoute>
          }
        />
        {/* --- NEWS --- */}
        <Route
          path="news"
          element={
            <PermissionRoute perm="VIEW_NEWS">
              <News />
            </PermissionRoute>
          }
        />
        <Route
          path="news/:id"
          element={
            <PermissionRoute perm="VIEW_NEWS">
              <NewsDetail />
            </PermissionRoute>
          }
        />
        {/* --- CALL CENTER --- */}
        <Route
          path="call-center"
          element={
            <PermissionRoute perm="VIEW_CALL_LIST">
              <CallCenter />
            </PermissionRoute>
          }
        />
        <Route
          path="call-center/:id"
          element={
            <PermissionRoute perm="VIEW_CALL_LIST">
              <CallCenterDetail />
            </PermissionRoute>
          }
        />
        {/* --- REWARD --- */}
        <Route
          path="reward"
          element={
            <PermissionRoute perm="VIEW_REWARDS">
              <Reward />
            </PermissionRoute>
          }
        />
        <Route
          path="reward/:id"
          element={
            <PermissionRoute perm="VIEW_REWARDS">
              <Grants />
            </PermissionRoute>
          }
        />
        {/* --- ROLES --- */}
        <Route
          path="roles"
          element={
            <PermissionRoute perm="VIEW_ROLE">
              <Roles />
            </PermissionRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default App;
